import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const inspectionColumns: GridColumnConfig[] = [
  {
    title: 'Work Order #',
    field: 'workorderNumber',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    width: '382',
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width: '282',
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
    width: '350',
  },
  // {
  //   title: 'Forecasted Date',
  //   field: 'forecastedDate',
  //   filter: 'text',
  //   width: '150',
  // },
  {
    title: 'Scheduled Date',
    field: 'scheduledDate',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Scheduled/Created User',
    field: 'scheduleCreatedUser',
    filter: 'text',
    width: '220',
  },
  // {
  //   title: 'Insp. Cut off Time',
  //   field: 'cutOffTime',
  //   filter: 'text',
  //   width: '150',
  // },
  {
    title: 'Due Date',
    field: 'dueDate',
    filter: 'text',
    width: '150',
  },
  {
    title: 'Assigned To',
    field: 'inspectorName',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Status',
    field: 'workOrderStatus',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Active/Inactive Work Order Status',
    field: 'workOrderActiveStatus',
    filter: 'text',
    width: '250',
    searchable: true,
  },
];
